import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RefreshTokenCustomer } from '../../api/authApi';
import { setAccessToken } from '../../api/axiosConfig';
import Cookies from 'js-cookie';

// JWT payload-ı decode edir (yalnız oxumaq üçün, verify etmir)
const decodeJwtPayload = (token: string): any => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64).split('').map(c =>
        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      ).join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

const LoadingPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const parsedUrl = new URL(window.location.href);
    const refreshToken = parsedUrl.searchParams.get("refresh_token");

    if (!refreshToken) {
      navigate('/login');
      return;
    }

    const handleRefreshToken = async () => {
      try {
        const result = await RefreshTokenCustomer(refreshToken);

        if (result.success && 'access' in result.data && result.data.access) {
          const accessToken = result.data.access;
          setAccessToken(accessToken);

          if ('refresh' in result.data && result.data.refresh) {
            Cookies.set('refreshToken', result.data.refresh, {
              secure: process.env.NODE_ENV === 'production',
              sameSite: 'strict'
            });
          }

          // JWT-dən user məlumatlarını birbaşa oxu — localStorage-ə etibar etmə
          const payload = decodeJwtPayload(accessToken);
          const phoneNumber = payload?.phone_number || payload?.phone || null;
          const userId = payload?.user_id || payload?.id || payload?.sub || payload?.pk;

          // user_info-nu localStorage-ə yaz
          if (payload) {
            localStorage.setItem('user_info', JSON.stringify(payload));
          }

          if (!phoneNumber || String(phoneNumber).trim() === '') {
            // Nömrə yoxdur — login səhifəsinə qayıt, modal göstər
            localStorage.setItem('needsPhoneNumber', 'true');
            if (userId) {
              localStorage.setItem('currentUserId', String(userId));
            }
            navigate('/login');
            return;
          }

          // Nömrə var — kabinetə daxil ol
          localStorage.setItem('isAuthenticated', 'true');
          navigate('/');
        } else {
          console.error('Token yeniləmə uğursuz oldu:', result.data);
          navigate('/login');
        }
      } catch (error) {
        console.error('Token yeniləmə zamanı xəta:', error);
        navigate('/login');
      }
    };

    handleRefreshToken();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-700 mx-auto mb-4"></div>
        <p className="text-gray-600">Yüklənir...</p>
      </div>
    </div>
  );
};

export default LoadingPage;